import { Suspense } from 'react';
import { Navigate, Outlet, useParams } from 'react-router-dom';
import { DEFAULT_LANGUAGE, isSupportedLanguage } from '@app/i18n/languages';
import { PageLoader } from '@shared/components/PageLoader';
import { LanguageBoundary } from '@shared/i18n/LanguageBoundary';

export const LocalizedRoutes = () => {
  const { lng } = useParams();

  // At the bare root there is no :lng param — default to Spanish instead of
  // redirecting. An explicit but unsupported language (e.g. /fr) still bounces.
  const language = lng ?? DEFAULT_LANGUAGE;

  if (!isSupportedLanguage(language)) {
    return <Navigate to={`/${DEFAULT_LANGUAGE}`} replace />;
  }

  return (
    <LanguageBoundary language={language}>
      <Suspense fallback={<PageLoader />}>
        <Outlet />
      </Suspense>
    </LanguageBoundary>
  );
};
